/**
 * `468` — *push {due date, dateColumnId} by {some days, duration}*. Reads the current date cell,
 * adds the duration and writes it back. An **empty cell is a no-op** (ASSUMED — "push from
 * today" is not evidenced, open question 28), and so is a zero duration.
 */
import { z } from 'zod';
import { defineAction } from '../block.js';
import { applyOffset, startOfUtcDay } from '../schedule.js';
import { columnRefSchema, durationSchema } from '../values.js';
export const pushDateParams = z.object({
    dateColumnId: columnRefSchema,
    duration: durationSchema,
});
export const pushDateAction = defineAction({
    id: '468',
    kind: 'action',
    app: 'monday',
    sentencePartial: 'push {due date, dateColumnId} by {some days, duration}',
    paramsSchema: pushDateParams,
    requiredColumnTypes: ['date'],
    executable: true,
    references: (params) => [{ kind: 'column', id: params.dateColumnId.columnId, invalid: params.dateColumnId.invalid }],
    async execute(context, params) {
        if (context.itemId === null)
            return { skipped: 'no_item' };
        const current = await context.services.getCellValue(context.itemId, params.dateColumnId.columnId);
        const date = typeof current === 'object' && current !== null ? current.date : undefined;
        if (typeof date !== 'string' || date.length === 0)
            return { skipped: 'empty_date' };
        let shifted = startOfUtcDay(new Date(`${date}T00:00:00Z`));
        let moved = false;
        for (const [unit, count] of Object.entries(params.duration)) {
            if (count === 0 || count === undefined)
                continue;
            shifted = applyOffset(shifted, { count, unit: unit });
            moved = true;
        }
        if (!moved)
            return { skipped: 'zero_duration' };
        const value = { ...current, date: shifted.toISOString().slice(0, 10) };
        const result = await context.services.setCellValue({
            boardId: context.boardId,
            itemId: context.itemId,
            columnId: params.dateColumnId.columnId,
            value,
        });
        return { date: value.date, changed: result.changed };
    },
});
//# sourceMappingURL=468.js.map